module.exports = __webpack_public_path__ + "img/hzmbg-vehicle-personal-sample.08f887bd.png";